import { statisticEssentialQuery } from '../common'

const table = 'statistics_program'

export const getStatisticProgram = async regionId => {
    try {
        return await statisticEssentialQuery(table, regionId)
    } catch (error) {
        console.error(error)
        return null
    }
}
